import { SVGProps, Ref, forwardRef } from 'react';

export const ChartLineOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m12.987 6.332-.99-.99-3.332 3.332-2.333-2.332-3.323 3.322.99.99 2.333-2.333 2.333 2.333z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 1.438 1.438.5 8 .5s7.5.938 7.5 7.5-.937 7.5-7.5 7.5S.5 14.563.5 8m1.4 0c0-1.63.06-2.808.225-3.681.162-.86.4-1.287.654-1.54.253-.253.68-.492 1.54-.654C5.192 1.96 6.37 1.9 8 1.9s2.808.06 3.681.225c.86.162 1.287.4 1.54.654.253.253.492.68.654 1.54.165.873.225 2.051.225 3.681s-.06 2.808-.225 3.681c-.162.86-.4 1.287-.654 1.54-.253.253-.68.492-1.54.654-.873.165-2.051.225-3.681.225s-2.808-.06-3.681-.225c-.86-.162-1.287-.4-1.54-.654-.253-.253-.492-.68-.654-1.54C1.96 10.808 1.9 9.63 1.9 8"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ChartLineOutlinedSize16Glyph.displayName = 'ChartLineOutlinedSize16Glyph';
